import * as React from 'react';
import { Close16 } from '@cian/ui-kit/icons';
import * as styles from './styles.css';

export interface IFullscreenGalleryCloseButtonProps {
  onClick(): void;
}

export function CloseButton({ onClick }: IFullscreenGalleryCloseButtonProps) {
  return (
    <button type="button" onClick={onClick} className={styles['close_button']} aria-label="Закрыть">
      <Close16 />
    </button>
  );
}
